module.exports = __webpack_public_path__ + "assets/language-squares/en@2x-f1ca8d67edc2f9ab70e276f071c05c2f.jpg";